(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["shared-basket"] = factory();
	else
		root["shared-basket"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 